import { tv } from 'tailwind-variants';

const containerStyles = tv({
    base: `
    iris:mx-(--sem-space-page-margin-sm)
    iris:box-border
    iris:flex
    iris:max-w-none
    iris:flex-shrink-0
    iris:flex-grow
    iris:flex-col
    iris:md:mx-(--sem-space-page-margin-md)
    iris:lg:mx-(--sem-space-page-margin-lg)
    iris:xl:mx-(--sem-space-page-margin-xl)
  `,
    variants: {
        display: {
            initial: "iris:flex",
            none: "iris:hidden",
        },
        align: {
            left: "iris:items-start",
            center: "iris:items-center",
            right: "iris:items-end",
        },
        maxWidth: {
            none: `
        iris:md:mx-0
        iris:lg:mx-0
        iris:xl:mx-0
      `,
            md: "iris:max-w-(--sem-space-page-max-width-md)",
            lg: "iris:max-w-(--sem-space-page-max-width-lg)",
        },
    },
});

export { containerStyles as default };
